export default "__VITE_ASSET__wXCV5YYt__"